
/**
 * Cache utility specifically for the welcome page to reduce database reads
 */
class WelcomePageCache {
  private static instance: WelcomePageCache;
  private tokenValidationCache: Map<string, { 
    isValid: boolean; 
    invitation: any | null;
    timestamp: number;
  }> = new Map();

  // Cache TTL - 5 minutes
  private CACHE_TTL = 5 * 60 * 1000;

  private constructor() {}

  public static getInstance(): WelcomePageCache {
    if (!WelcomePageCache.instance) {
      WelcomePageCache.instance = new WelcomePageCache();
    }
    return WelcomePageCache.instance;
  }

  /**
   * Store token validation result
   */
  public cacheTokenValidation(token: string, isValid: boolean, invitation: any | null): void {
    this.tokenValidationCache.set(token, {
      isValid,
      invitation,
      timestamp: Date.now()
    });
  }

  /**
   * Get cached token validation result if available and not expired
   */
  public getCachedTokenValidation(token: string): { isValid: boolean; invitation: any | null } | null {
    const cachedResult = this.tokenValidationCache.get(token);
    
    if (!cachedResult) {
      return null;
    }

    // Check if cache has expired
    if (Date.now() - cachedResult.timestamp > this.CACHE_TTL) {
      this.tokenValidationCache.delete(token);
      return null;
    }

    return {
      isValid: cachedResult.isValid,
      invitation: cachedResult.invitation
    };
  }

  /**
   * Clear all cached data
   */
  public clearCache(): void {
    this.tokenValidationCache.clear();
  }
}

export default WelcomePageCache.getInstance();
